export default "__VITE_ASSET__D14HDUE___"